"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread4 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));

var initialState = {
  data: {
    email: '',
    password: '',
    fullname: ''
  },
  errors: {},
  isPolicyCheck: false,
  seePassword: false,
  isErrors: true
};
var styles = {
  email: {
    textTransform: 'lowercase'
  },
  captcha: {
    padding: '0 0 6px',
    transform: 'scale(0.87)',
    transformOrigin: '0 0'
  }
};

var FormState =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FormState, _Component);

  function FormState() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, FormState);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(FormState)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", (0, _objectSpread4["default"])({}, initialState));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (event) {
      var _this$state = _this.state,
          data = _this$state.data,
          errors = _this$state.errors;
      var _event$currentTarget = event.currentTarget,
          name = _event$currentTarget.name,
          value = _event$currentTarget.value;
      var key = name;
      var fieldValue = value;

      _this.props.clearServerError();

      _this.setState({
        data: (0, _objectSpread4["default"])({}, data, (0, _defineProperty2["default"])({}, key, fieldValue)),
        errors: (0, _objectSpread4["default"])({}, errors, (0, _defineProperty2["default"])({}, key, ''))
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubmit", function (event) {
      event.preventDefault();
      var data = _this.state.data;
      var _this$props = _this.props,
          submit = _this$props.submit,
          isSignUpForm = _this$props.isSignUpForm;

      var errors = _this.validate(data);

      _this.setState({
        errors: errors
      }); // we are checking the errors from the variable above not the state
      // since the errors in state is only used to show the errors.


      var noErrors = Object.keys(errors).length === 0;

      if (noErrors) {
        if (!isSignUpForm) {
          var loginData = {
            email: data.email,
            password: data.password
          };
          submit(loginData);
        } else {
          submit(data);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "validate", function (data) {
      var email = data.email,
          password = data.password,
          fullname = data.fullname;
      var errors = {};
      var fullNameRegex = /[^\s]/;
      if (!(0, _isEmail["default"])(email)) errors.email = 'Please enter a valid email';
      if (!password) errors.password = 'Please enter a valid password';
      if (!email) errors.email = 'Please enter a valid email';
      if (password.length > 0 && password.length < 6) errors.password = 'Minimum of 6 characters required, captain!'; // validation check when the user registers

      if (_this.isTheTypeRegister()) {
        var isPolicyCheck = _this.state.isPolicyCheck;
        if (!fullNameRegex.test(fullname)) errors.fullname = 'Please enter a valid name';
        if (!isPolicyCheck) errors.security = 'Please confirm the boxes';
      }

      return errors;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isTheTypeRegister", function () {
      return !!_this.props.isSignUpForm;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCheckboxChange", function (e) {
      _this.setState((0, _defineProperty2["default"])({}, e.target.name, e.target.checked));

      _this.emptyErrors('security');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCaptchaChecked", function (e) {
      _this.setState({
        isCaptchaCheck: true
      });

      _this.emptyErrors('captcha');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "emptyErrors", function (key) {
      var errors = _this.state.errors;
      var isErrors = errors[key] && errors[key].length > 0;
      if (isErrors) errors[key] = '';
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "togglePassword", function () {
      return _this.setState({
        seePassword: !_this.state.seePassword
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(FormState, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUserChangeLoginOrSignup = prevProps.buttonText !== this.props.buttonText;
      if (didUserChangeLoginOrSignup) this.setState((0, _objectSpread4["default"])({}, initialState));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          _this$state2$data = _this$state2.data,
          email = _this$state2$data.email,
          password = _this$state2$data.password,
          fullname = _this$state2$data.fullname,
          errors = _this$state2.errors,
          seePassword = _this$state2.seePassword;
      var _this$props2 = this.props,
          loading = _this$props2.loading,
          buttonText = _this$props2.buttonText,
          loadingTextIndicator = _this$props2.loadingTextIndicator,
          isSignUpForm = _this$props2.isSignUpForm;
      return _react["default"].createElement(_react.Fragment, null, isSignUpForm && _react["default"].createElement(_reactstrap.FormGroup, null, _react["default"].createElement(_reactstrap.Input, {
        type: "name",
        name: "fullname",
        id: "name",
        value: fullname,
        onChange: this.handleChange,
        placeholder: "full name"
      }), _react["default"].createElement(_reactstrap.FormFeedback, {
        className: "error"
      }, errors.fullname)), _react["default"].createElement(_reactstrap.FormGroup, null, _react["default"].createElement(_reactstrap.Input, {
        type: "name",
        name: "email",
        id: "email",
        value: email,
        onChange: this.handleChange,
        placeholder: "email address",
        style: styles.email
      }), _react["default"].createElement(_reactstrap.FormFeedback, {
        className: "error"
      }, errors.email)), _react["default"].createElement(_reactstrap.FormGroup, {
        className: "mb-2"
      }, _react["default"].createElement(_reactstrap.InputGroup, null, _react["default"].createElement(_reactstrap.Input, {
        type: seePassword ? 'text' : 'password',
        name: "password",
        id: "password",
        value: password,
        onChange: this.handleChange,
        placeholder: "Enter your password"
      }), _react["default"].createElement(_reactstrap.InputGroupAddon, {
        onClick: this.togglePassword,
        addonType: "append"
      }, _react["default"].createElement("span", {
        className: "input-group-text"
      }, _react["default"].createElement("i", {
        className: "icon icon-hg-eye"
      })))), _react["default"].createElement(_reactstrap.FormFeedback, {
        className: "error"
      }, errors.password)), isSignUpForm && _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("ul", {
        className: "permi"
      }, _react["default"].createElement("li", null, _react["default"].createElement("label", null, _react["default"].createElement("input", {
        type: "checkbox",
        name: "isPolicyCheck",
        onChange: this.onCheckboxChange
      }), _react["default"].createElement("span", null), "By submitting this form I agree to HoneyGuide`s", ' ', _react["default"].createElement("a", {
        href: "/policies/terms-services",
        target: "_blank"
      }, "Terms of Services"), ' ', "and", ' ', _react["default"].createElement("a", {
        href: "/policies/privacy",
        target: "_blank"
      }, "Privacy Policies")))), _react["default"].createElement("div", {
        className: "error"
      }, errors.security)), _react["default"].createElement(_reactstrap.Button, {
        type: "submit",
        color: "primary",
        className: loading ? 'btn-social btn-loading' : 'btn-social',
        onClick: this.handleSubmit
      }, loading ? loadingTextIndicator : buttonText));
    }
  }]);
  return FormState;
}(_react.Component);

exports["default"] = FormState;
(0, _defineProperty2["default"])(FormState, "defaultProps", {
  isSignUpForm: true,
  clearServerError: function clearServerError() {},
  loadingTextIndicator: 'JOINING',
  buttonText: 'JOIN HONEYGUIDE'
});